import { AdditionalInfoOfAsset, Asset as AssetType } from './asset';
import { Resource as AttachmentInterface, ResourceAdditionalInfo, ResourceType } from './resource';
import { Contract as ContractInterface, ContractAdditionalInfo } from './contract';
import { HubEntityType } from './hub-entity-type';
import { AdditionalInfoOfModule, HubModule } from './module';
import { HubProject, MethodAdditionalInfo, ProjectAdditionalInfo } from './project';
import { Method as MethodInterface } from '@core/interfaces/method';

export enum CategoryTypeOfSearch {
  Any = 'any',
  Asset = 'asset',
  Method = 'method',
  Module = 'module',
  Project = 'project',
  Solution = 'solution',
  Contract = 'contract',
  Bookmark = 'bookmarked',
  Resource = 'resource',
  Service = 'service',
}

export type AssetInterface = AssetType & { type: HubEntityType.Asset };

export interface ResultOfMainSearch {
  class: string;
  data: (
    | HubModule
    | HubProject
    | AssetInterface
    | ContractInterface
    | AttachmentInterface
    | MethodInterface
  ) & {
    type?: HubEntityType;
  };
  isAttached?: boolean;
  additionalInfo?:
    | AdditionalInfoOfModule
    | ProjectAdditionalInfo
    | AdditionalInfoOfAsset
    | ContractAdditionalInfo
    | MethodAdditionalInfo
    | ResourceAdditionalInfo;
  project?: HubProject;
  contract?: ContractInterface;
  module?: HubModule;
  asset?: AssetInterface;
  method?: MethodInterface;
  attachment?: AttachmentInterface;
  assetAdditionalInfo?: AdditionalInfoOfAsset;
  contractAdditionalInfo?: ContractAdditionalInfo;
  methodAdditionalInfo?: MethodAdditionalInfo;
}

export interface SearchResponse {
  elements: ResultOfMainSearch[];
  total: number;
}

export interface SearchResultCountStats {
  numOfModules?: number;
  numOfAssets?: number;
  numOfProjects?: number;
  numOfContracts?: number;
  numOfMethods?: number;
  numOfAttachments?: number;
  numOfConnections?: number;
  attachmentType?: ResourceType;
}
